import React from "react";
import useResponsive from "core/hooks/useResponsive";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel as ResponsiveCarousel } from "react-responsive-carousel";
import "./style.scss";
import { Button } from "react_reusable_components";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export default function Carousel({
  slides = ["/BannerImage1.png", "/BannerImage2.png", "/BannerImage1.png"],
}) {
  const responsive = useResponsive();
  return (
    <ResponsiveCarousel
      interval={3000}
      autoPlay
      infiniteLoop
      {...(responsive.isMd && {
        renderArrowPrev: (onClickHandler) => (
          <CustomPrevButton onClick={onClickHandler} />
        ),
        renderArrowNext: (onClickHandler) => (
          <CustomNextButton onClick={onClickHandler} />
        ),
      })}
      showStatus={false}
      showArrows={responsive.isMd}
      renderIndicator={(onClickHandler, isSelected, index) => (
        <li
          onClick={onClickHandler}
          className={`custom-dot ${isSelected ? "selected" : ""}`}
          key={index}
          role="button"
        />
      )}
      showIndicators={responsive.isMd}
      showThumbs={false}
    >
      {slides.map((src) => (
        <div key={src}>
          <img
            className={responsive.isMd ? "Carousel-md" : "Carousel-mb"}
            src={src}
          />
        </div>
      ))}
    </ResponsiveCarousel>
  );
}

const CustomPrevButton = ({ onClick }) => (
  <Button
    className="custom-carousel-button-left"
    onClick={onClick}
    size="small"
    type="primary"
    icon={ <LeftOutlined />}
  />
   
);

const CustomNextButton = ({ onClick }) => (
  <Button
    size="small"
    type="primary"
    className="custom-carousel-button-right"
    onClick={onClick}
    icon={<RightOutlined />}
  />
    
);
